<template>
    <div class="versionsSet">
        <h1>版本管理</h1>
        <div class="versionsTable">
            <div class="btns">
                <span>游戏有且仅有一个启用的版本为当前使用版本，其余版本主要用于历史数据重新算分。请谨慎修改</span>
                <a-button type="primary" @click="openModal()" icon="plus">添加版本
                </a-button>
            </div>
            <a-table :columns="versionscolumns"
                     row-key="id"
                     :expanded-row-keys.sync="expandedRowKeys"
                     :data-source="data"
                     :loading="tableLoading"
                     @expand="getAbility"
                     @expandedRowsChange="expandedRowsChange"
                     :expandedRowKeys="tableExpandedRowKeys"
                     class="components-table-demo-nested">
                <div slot="version" slot-scope="text, record">
                    <div class="table_div">
                        <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0 && currentEnabled == 'true' && text.enabled"/>
                        {{text.version }}
                    </div>
                </div>
                <div slot="status" slot-scope="text, record">
                    <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled"
                              @click="StatusChange(record)"/>
                </div>
                <div slot="action" slot-scope="text, record">
                    <a @click="editModal(record)">
                        <a-icon type="edit"/>
                        编辑</a>
                    <a-popconfirm title="确定删除？" ok-text="确定"
                                  cancel-text="取消" @confirm="deleteVersion(record)" style="margin-left: 15px">
                        <a style="color: #f00;">
                            <a-icon type="delete"/>
                            删除
                        </a>
                    </a-popconfirm>
                </div>
                <a-table
                    slot="expandedRowRender"
                    slot-scope="text, record"
                    :row-key="(text, record) => text.id + record"
                    :columns="innerColumns"
                    :data-source="innerData"
                    :pagination="false"
                >
          <span slot="code" slot-scope="text, record">
            <a-select style="width: 172px" show-search :filter-option="filterOption" @change="handleChange"
                      :key="record.code" :default-value="record.code">
              <a-select-option :value="item" v-for="item in codesList" :key="item.id"
                               @click="getRecord(record)">{{ item }}</a-select-option>
            </a-select>
          </span>
                    <span slot="operation"
                          class="table-operation" slot-scope="text, record">
            <a @click="normSeting(record)" v-if="record.codeBindId">常模配置</a>
            <a class="noClick" v-else>常模配置</a>
          </span>
                </a-table>
            </a-table>
        </div>
        <!-- 编辑添加版本 -->
        <a-modal v-model="isVersions" :title="versionsTit" @ok="VersionsOk">
            <a-form-model
                ref="ruleForm"
                :model="versionsForm"
                :rules="versionsRules"
                :label-col="{span:6}"
                :wrapper-col="{span:14}"
            >
                <a-form-model-item ref="version" label="游戏版本" prop="version">
                    <a-input v-model.trim="versionsForm.version"/>
                </a-form-model-item>
                <a-form-model-item ref="uri" label="游戏地址" prop="uri">
                    <a-input v-model.trim="versionsForm.uri"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
const versionscolumns = [
    {title: "游戏版本",scopedSlots: {customRender: "version"}, key: "version"},
    {title: "游戏地址", dataIndex: "uri", key: "uri"},
    {title: "创建时间", dataIndex: "createTime", key: "createTime", align: 'center'},
    {title: "状态", scopedSlots: {customRender: "status"}, key: "enabled", align: 'center'},
    {title: "操作", key: "action", scopedSlots: {customRender: "action"}, align: 'center'}
];
const innerColumns = [
    {title: "能力类型", dataIndex: "abilityTypeName", align: "center"},
    {title: "一级能力", dataIndex: "firstAbilityName", align: "center"},
    {title: "二级能力", dataIndex: "secondAbilityName", align: "center"},
    {title: "科学名称", dataIndex: "scientificName", align: "center"},
    {title: "算分码", dataIndex: "code", align: "center", scopedSlots: {customRender: "code"}},
    {title: "操作", dataIndex: "operation", key: "operation", scopedSlots: {customRender: "operation"}}
];
export default {
    name: "versionsSet",
    data() {
        return {
            type: '',//添加、编辑
            data: [],//版本数据
            expandedRowKeys: [], //展开的行
            versionscolumns,//版本表头
            innerColumns,//版本能力表头
            innerData: [],//版本能力数据
          tableLoading: false,
            isVersions: false,//是否编辑添加版本
            // 编辑添加版本表单
            versionsForm: {
                contentId: this.$store.getters["content/getEvaluationGameInfo"]().id,//当前游戏id
                version: '',//版本号
                uri: '',//地址url
                enabled: false,//状态
                remark: '',//备注
            },
            // 编辑添加版本表单校验规则
            versionsRules: {
                version: [
                    {required: true, message: '请填写游戏版本', trigger: 'blur'},
                    {max: 30, message: '游戏版本最大长度为 30 个字符', trigger: 'blur'}
                ],
                uri: [
                    {required: true, message: '请填写游戏地址', trigger: 'blur'},
                    {max: 245, message: '游戏地址最大长度为 245 个字符', trigger: 'blur'}
                ],
            },
            codesList: [],//算分码数据
            record: {},
            selectCodeId: '',//选择算分码id
            versionsTit: '',//编辑添加版本弹窗title
            versionId: '',//版本id
            currentId: this.$store.getters["content/getEvaluationGameInfo"]().id,//当前游戏id
            tableExpandedRowKeys: [], //表格展开的行
            currentEnabled: this.$store.getters["content/getEvaluationGameInfo"]().enabled
        };
    },
    watch: {
        isVersions() {
            if (!this.isVersions) {
                this.$refs.ruleForm.resetFields();
            }
        }
    },
    created() {
        console.log(this.currentEnabled);
        // 获取版本数据
        this.getVersion()
        // 获取所有算分码
        this.getAllCodes()
    },
    methods: {
        // 展开行
        expandedRowsChange(expandedRowKeys) {
            if (expandedRowKeys.length > 1) {
                this.tableExpandedRowKeys = [expandedRowKeys.pop()];
            } else {
                this.tableExpandedRowKeys = expandedRowKeys;
            }
        },
        // 修改版本状态
        StatusChange(record) {
          this.tableLoading = true;
            this.$http.updateVersionStatus({
                id: record.id,
                enabled: !record.enabled
            }).then(res => {
              record.enabled = !record.enabled
              this.$message.destroy()
              this.$message.success('修改成功')
              this.getVersion();
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        // 添加编辑弹窗确定按钮
        VersionsOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.type == 'add') {
                        this.addVersion()
                    } else {
                        this.editVersion()
                    }
                } else {

                }
            })
        },
        // 添加版本
        openModal() {
            this.type = 'add'
            this.versionsTit = '添加版本'
            this.versionsForm = {
                contentId: sessionStorage.getItem("evacurrentId"),//当前游戏id
                version: '',//版本号
                uri: '',//地址url
                enabled: false,//状态
                remark: '',//备注
            };
            this.isVersions = true
        },
        // 编辑版本
        editModal(record) {
            this.type = 'edit'
            this.versionsTit = '编辑版本'
            this.isVersions = true
            for (let key in record) {
                for (let k in this.versionsForm) {
                    if (k == key) {
                        this.versionsForm[key] = record[key]
                    }
                }
            }
            this.versionsForm.contentId = this.currentId
            this.versionsForm.id = record.id
        },
        // 获取全部算分码
        getAllCodes() {
            this.$http.getAllCodes()
                .then(res => {
                        this.codesList = res.data.data
                });
        },
        // 绑定算分码
        bindCode(code) {
            let params = {
                contentId: this.currentId,
                id: this.selectCodeId || undefined,//选中算分码id
                contentAbilityId: this.versionId,//选中能力数据id
                contentVersionId: this.record.id,//选中版本数据的id
                algorithmCode: code,//选中的算分码
            }
            this.$http.bindCode(params)
                .then(res => {
                        this.$message.success(res.data.message);
                        this.getAbility(true, this.record)
                    
                });
        },
        getRecord(record) {
            this.selectCodeId = record.codeBindId
            this.versionId = record.id
        },
        // 算分码下拉框选中
        handleChange(value) {
            this.bindCode(value)
        },
        // 算分码下拉框搜索
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        // 获取版本
        getVersion() {
            let params = {
                id: this.currentId
            };
          this.tableLoading = true;
            this.$http.EGamegeVersion(params)
                .then(res => {
                        this.data = res.data.data
                }).finally(() => {
                  this.tableLoading = false;
            });
        },
        // 添加版本
        addVersion() {
            this.$http.addContentVersion(this.versionsForm)
                .then(res => {
                        this.resetForm();
                        this.isVersions = false
                        this.$message.success('添加成功');
                        this.getVersion()
                  
                });
        },
        // 编辑版本
        editVersion() {
            this.$http.updataContentVersion(this.versionsForm)
                .then(res => {
                        this.resetForm();
                        this.isVersions = false
                        this.$message.success('修改成功');
                        this.getVersion()
                   
                });
        },
        // 删除版本
        deleteVersion(record) {
            this.$message.destroy();
            if (record.enabled) {
                this.$message.warning('请先停用该版本');
                return
            }
            let formData = new FormData()
            formData.append('id', record.id)
            this.$http.deleteContentVersion(formData)
                .then(res => {
                        this.$message.success('删除成功');
                        this.getVersion()
                   
                });
        },
        // 获取版本下能力
        getAbility(expanded, record) {
            if (expanded) {
                if (this.expandedRowKeys.length > 1) {
                    this.expandedRowKeys.shift();
                }
                this.record = record
                let params = {
                    ContentVersionId: record.id,
                    ContentId: record.contentId
                };
                this.$http.getAbilityListByVersionId(params).then(res => {
                        this.innerData = res.data.data
                });
            }
        },
        resetForm() {
            this.versionsForm = {
                contentId: this.currentId,
                version: '',
                uri: '',
                status: false,
            }
        },
        // 常模配置
        normSeting(record) {
            let version = ''//版本号
            this.data.forEach(item => {
                if (item.id == record.contentVersionId) {
                    version = item.version
                }
            })
          this.$store.commit("content/setAbilityInfo", record);
            this.$router.push({
                path: "/content/normSeting",
                query: {
                    activekey: 1,
                    id: record.id,
                    name: record.name,
                    type: 'game',
                    version: version,
                    ContentAlgorithmCodeConfigId: record.codeBindId,
                    abilityId: record.abilityTypeId,
                    contentId:this.$route.query.id,
                    classifyTag:this.$store.getters["content/getEvaluationGameInfo"]().classifyTag,
                    fullPath: encodeURIComponent(this.$route.fullPath)
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.versionsSet {
    width: 100%;

    h1 {
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
    }

    .btns {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            font-size: 14px;
        }
    }

    .noClick {
        color: #ccc;
        cursor: default;
    }
}
.table_div{
  display: flex;
  align-items: center;
}
.table_icon{
  color:#ff9904;
  font-size:24px;
  margin-right: 5px;
}
</style>
